import { getAssetURL } from 'src/constants/BlockchainConstants'
import { useAppSelector } from 'src/store/store'
import { maskHash } from 'src/constants/ConversionUtils'
import { CopyLink } from 'src/components/shared/CopyLink'

type Props = {
  denom: string
  shouldTruncate?: boolean
  className?: string
}

export const ScanDenomLink: React.FC<Props> = ({
                                                 denom,
                                                 shouldTruncate = false,
                                                 className,
                                               }) => {
  const selector = useAppSelector
  const network = selector((state) => state.NetworkReducer.network)

  if (!denom) {
    return <div>{'-'}</div>
  }

  // link to transactions page in respective explorers
  const explorerUrl = getAssetURL('carbon', denom, network)
  if (!explorerUrl) {
    return <div>{denom.slice(0, 5)}... (Link not found)</div>
  }

  const formattedHash = shouldTruncate
    ? maskHash(denom, 12)
    : denom

  return <CopyLink copyText={denom} text={formattedHash} url={explorerUrl} className={className} />
}
